/* eslint-disable */
import React from "react";
import { connect } from "react-redux";
import { withRouter, useHistory } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import { templateStrings, BASE_URL, NEW_BASE_URL } from "../../../../Constant";
import { newReconServiceAPI, reconServiceAPI } from "../../../../services/APIutils";
import { BarLoader, GenericLoader } from "../../../../shared/widgets";
import { PageWrapper, TableWrapper } from "../../../../shared/layout";
import { getSettlementTemplateString } from "../../../../shared/methods/sharedMethods";

const useStyles = makeStyles(() => ({
  root: {
    flexGrow: 1,
  },
}));

function PreSettleDropDown(props) {
  const [dataLoad, setDataLoad] = React.useState(false);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [result, setResult] = React.useState({});

  const classes = useStyles();
  const history = useHistory();
  const templateStringDetail = result?.calculationConfig && getSettlementTemplateString(result?.calculationConfig, templateStrings.previousSettlemntsDetails);
  const operatorName = props.location.state?.operatorName || "";

  React.useEffect(() => {
    fetchDetails(page, history.location.state?._id);
  }, [page, rowsPerPage]);

  const fetchDetails = (page, idFilter = "") => {
    const url = `${NEW_BASE_URL}/v1/settlementsPage/previousSettlementsDetails`;
    return newReconServiceAPI(url, {
      addOnFilter: { operatorPaymentId: idFilter },
      pageNo: page,
      pageSize: rowsPerPage,
    }).then((response) => {
      setDataLoad(true);
      setResult(response);
    });
  };

  const handleChange = (input, value) => {
    if (input === "rowsPerPage") {
      setRowsPerPage(value);
    } else {
      setPage(value);
    }
  };

  return (
    <div className={classes.root}>
      <PageWrapper>
        <div className="page-header">
          <div
            className="back-arrow"
            onClick={() => {
              history.replace("/settlement/operator-settlement", { ...props.location.state, isFromSettledDues: true });
            }}
            onKeyDown={
              (event) => event.key === "Enter" && history.replace("/settlement/operator-settlement", { ...props.location.state, isFromSettledDues: true })
            }
          >
            <div className="back-action" />
          </div>
          <div className="page-header-title">{operatorName}</div>
          <div className="pull-right">
            <div className="settlement-heading">
              <span className="flex">
                <p>Previous Balance - Rs.  </p>
                <p>
                  {!dataLoad
                    ? <GenericLoader size={20} />
                    : ((result?.previousBalance?.toLocaleString(undefined, { maximumFractionDigits: 2 })) || 0)}
                </p>
              </span>
            </div>
          </div>
        </div>
        <div>
          <PageWrapper.Header hideS />
        </div>
        <BarLoader scope="header" />
        <div>
          {/* // 3rd Table  */}
          <TableWrapper
            content={(dataLoad && result?.items) || []}
            selected={[]}
            pageNo={page}
            uniqueKey="_id"
            rowsPerPage={rowsPerPage}
            count={result?.totalItems || 0}
            handleChange={handleChange}
            templateString={templateStringDetail || {}}
            selectionAllowed={false}
            tableContainerClassName="day-wise-dues-breakdown"
          />
        </div>
      </PageWrapper>
    </div>
  );
}

function mapStateToProps(state) {
  return {
  };
}

const mapDispatchToProps = (dispatch, state) => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(PreSettleDropDown));
